import React from 'react';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import starFilledTokens from '@amzn/meridian-tokens/base/icon/star-filled';
import { HeroBannerProps } from '../model';
import { formatTriggersMet } from '../../../utils/leaderboard-utils';

const HeroBanner: React.FC<HeroBannerProps> = ({ siteName, planCount, daysActive, dayPlans, nightPlans }) => {
  return (
    <Box type="outline" spacingInset="none" className="hero-banner">
      <Box spacingInset="400" className="hero-banner__header">
        <Row alignmentVertical="center" spacing="300">
          <span className="leaderboard-icon"><Icon tokens={starFilledTokens} /></span>
          <Column spacing="none">
            <Text type="h100">BEST SITE OF LAST WEEK</Text>
            <Heading level={2}>{siteName} — Top performing site</Heading>
          </Column>
        </Row>
      </Box>
      {/* Description */}
      <Box spacingInset="400 400 none 400">
        <Text type="b300">
          <strong>{siteName} led all sites with {planCount} shift plans last week.</strong>{' '}
          Shift plans were generated ahead of schedule every day.
        </Text>
      </Box>
      {/* Stats area */}
      <Box spacingInset="400">
        <Row spacing="500">
          <Column spacing="100">
            <Heading level={3}>{planCount}</Heading>
            <Text type="b200" color="secondary">
              Shift plans generated
            </Text>
          </Column>
          <Column spacing="100">
            <Heading level={3}>{dayPlans}</Heading>
            <Text type="b200" color="secondary">
              Day plans
            </Text>
          </Column>
          <Column spacing="100">
            <Heading level={3}>{nightPlans}</Heading>
            <Text type="b200" color="secondary">
              Night plans
            </Text>
          </Column>
          <Column spacing="100">
            <Heading level={3}>{formatTriggersMet(daysActive)}</Heading>
            <Text type="b200" color="secondary">
              Days active
            </Text>
          </Column>
        </Row>
      </Box>
    </Box>
  );
};

export default HeroBanner;
